import {
    SET_LEGACY_MOBILE_FILTER_DROPDOWN_VALUE
} from '../actions/index';
import { persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage'; // defaults to localStorage for web

const initialState = {
    legacyMobileFilterDropdownValue: '',
};


const legacyMobileFilterReducer = (state = initialState, action) => {
    switch (action.type) {
        case SET_LEGACY_MOBILE_FILTER_DROPDOWN_VALUE:
            return {
                ...state,
                legacyMobileFilterDropdownValue: action.data
            };
        default:
            return {
                ...state,
            };
    }
};

export default persistReducer(
    {
        key: 'legacyMobileFilterReducerKey',
        storage: storage,
        whitelist: [
            'legacyMobileFilterDropdownValue',
        ],
    },
    legacyMobileFilterReducer
);